import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { PageLoader, PageLoaderWrapper } from 'shared-components/Loaders';

const CreateAccount = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    const options = { screen_hint: 'signup' };
    if (window.history.location?.state?.from) {
      options.state = {
        from : window.history.location.state?.from,
      };
    }
    loginWithRedirect(options);
  }, [loginWithRedirect]);

  return (
    <PageLoaderWrapper>
      <PageLoader />
    </PageLoaderWrapper>
  );
};

export default CreateAccount;
